import React from "react";
import { makeStyles } from "@mui/styles"; // Mise à jour ici
import Paper from "@mui/material/Paper";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    justifyContent: "center",
    flexWrap: "wrap",
    margin: "20px auto",
  },
  paper: {
    padding: 8,
  },
  link: {
    textDecoration: "none",
    color: "#413c3c",
  },
}));

export default function CustomBreadcrumb(props) {
  const { textLink } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Paper elevation={0} className={classes.paper}>
        <Breadcrumbs separator="›" aria-label="breadcrumb">
          <Link className={classes.link} color="inherit" to="/dashboard">
            Home
          </Link>
          <Typography>{textLink}</Typography>
        </Breadcrumbs>
      </Paper>
    </div>
  );
}
